

import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { GetCategoryOptions } from "../../../../Api/productVariations";

const flattenCategories = (categories, level = 0) => {
  return categories.reduce((acc, category) => {
    acc.push({
      value: category.value, 
      label: category.label,
      level,
    });

    if (category.childCategories && category.childCategories.length > 0) {
      acc.push(...flattenCategories(category.childCategories, level + 1));
    }

    return acc;
  }, []);
};

const CustomOption = ({ data, innerRef, innerProps }) => {
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        paddingLeft: `${data.level * 20}px`, 
        display: "flex",
        alignItems: "center",
      }}
    >
      <span style={{ marginRight: "8px" }}>
        {data.level > 0 && "•"} 
      </span>
      {data.label}
    </div>
  );
};

const CategoryFilter = ({ onCategoryChange }) => {
  
  const { data: categoriesData, isLoading } = useQuery({
    queryKey: ["get-category-option-list"],
    queryFn: GetCategoryOptions,
  });

  const [options, setOptions] = useState([]);

 
  useEffect(() => {
    if (categoriesData?.data) {
      const flattenedOptions = flattenCategories(categoriesData.data);
      setOptions(flattenedOptions);
    }
  }, [categoriesData]);

  return (
    <Select
      options={options}
      placeholder="Select Category"
      onChange={(selectedOption) =>
        onCategoryChange(selectedOption ? selectedOption.value : null)
      }
      isLoading={isLoading}
      components={{ Option: CustomOption }}
      isClearable
      styles={{
        option: (styles, { isDisabled }) => ({
          ...styles,
          cursor: isDisabled ? "not-allowed" : "pointer",
          marginTop: "0px",
          marginBottom: "0px",
        }),
        control: (styles, state) => ({
          ...styles,
          border: "2px solid #00000061",
          borderColor: state.isFocused ? "#AD5ADC" : "#F7F5F5",
          boxShadow: state.isFocused ? "0 0 0 1px #AD5ADC" : "none",
          borderRadius: "20px",
          minHeight: 42,
          paddingLeft: 6,
        }),
        placeholder: (styles) => ({
          ...styles,
          color: "#6b6b6b",
          // fontWeight: 500,
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#000",
          fontWeight: 400,
        }),
        menu: (styles) => ({
          ...styles,
          borderRadius: "20px",
          overflow: "hidden",
          cursor: "pointer",
        }),
      }}
    />
  );
};

export default CategoryFilter; 
